// Tinjauan "Bertindak Atas Nama" — K140 butir 6 (tinjauan sesudahnya = separuh nilai fitur ini).
//
// ⛔ LAHIR DARI SENSUS PINTU (23 Sep 2026): `GET /api/audit-logs/tinjauan-delegasi` berdiri tanpa
//    layar — laporannya ada, mata yang membacanya tidak. Owner SAJA (`require_owner` menolak juga
//    saat pemanggil sedang berdelegasi: laporan yang memeriksa delegasi tidak boleh dibaca lewat
//    delegasi). Alasan ditampilkan APA ADANYA — yang meninjau membaca kalimat orang yang
//    mendelegasi, bukan tafsiran sistem.
import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { apiErrorMessage } from "../lib/inventoryApi";
import { formatDateTime } from "../lib/format";
import { Card } from "../components/ui/card";

const PILIHAN_HARI = [7, 30, 90];

export default function TinjauanDelegasi() {
  const [hari, setHari] = useState(30);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  const muat = useCallback(async () => {
    setErr(null); setData(null);
    try {
      const r = await api.get("/audit-logs/tinjauan-delegasi", { params: { hari } });
      setData(r.data);
    } catch (e) {
      setErr(apiErrorMessage(e, "Laporan tinjauan delegasi gagal dimuat."));
    }
  }, [hari]);
  useEffect(() => { muat(); }, [muat]);

  return (
    <div className="space-y-4" data-testid="tinjauan-delegasi-page">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h1 className="text-2xl font-bold">Tinjauan Bertindak Atas Nama</h1>
        <div className="flex gap-2">
          {PILIHAN_HARI.map((h) => (
            <button key={h} onClick={() => setHari(h)} data-testid={`tinjauan-hari-${h}`}
                    className={`px-3 py-1 text-xs rounded border ${hari === h ? "bg-primary text-primary-foreground border-primary" : "bg-card text-muted-foreground border-border"}`}>
              {h} hari
            </button>
          ))}
        </div>
      </div>
      {err && <div className="text-sm text-danger-soft-foreground" data-testid="tinjauan-galat">{err}</div>}
      {!data && !err && <div className="text-sm text-muted-foreground">Memuat…</div>}
      {data && (
        <>
          <Card className="p-4 text-sm grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="tinjauan-ringkasan">
            <div><div className="text-xs text-muted-foreground">Sesi delegasi</div><div className="text-xl font-semibold">{data.jumlah_sesi}</div></div>
            <div><div className="text-xs text-muted-foreground">Tanpa alasan (wajib diisi)</div>
              <div className={`text-xl font-semibold ${data.tanpa_alasan ? "text-danger-soft-foreground" : ""}`}>{data.tanpa_alasan}</div></div>
            <div><div className="text-xs text-muted-foreground">Sesi tanpa tindakan</div><div className="text-xl font-semibold">{data.sesi_tanpa_tindakan}</div></div>
            <div><div className="text-xs text-muted-foreground">Peran yang dipinjam</div>
              <div>{Object.entries(data.per_peran_dipinjam || {}).map(([k, v]) => `${k} ${v}×`).join(" · ") || "—"}</div></div>
          </Card>
          {data.terpotong && (
            <div className="text-xs text-warning-soft-foreground" data-testid="tinjauan-terpotong">
              Menyentuh batas {data.batas_baris} sesi — laporan ini mungkin TIDAK lengkap. Persempit jendela hari.
            </div>
          )}
          <Card className="p-0 overflow-x-auto">
            <table className="w-full text-sm" data-testid="tinjauan-tabel">
              <thead className="text-xs text-muted-foreground border-b border-border">
                <tr>
                  <th className="text-left px-4 py-2">Mulai</th><th className="text-left">Oleh</th>
                  <th className="text-left">Atas nama</th><th className="text-left">Alasan</th>
                  <th className="text-left">Berakhir</th><th className="text-right px-4">Tindakan</th>
                </tr>
              </thead>
              <tbody>
                {(data.sesi || []).map((s) => (
                  <tr key={s.switch_id || s.pada} className="border-b border-border align-top">
                    <td className="px-4 py-2 whitespace-nowrap">{formatDateTime(s.pada)}</td>
                    <td>{s.oleh_email}<div className="text-xs text-muted-foreground">{s.peran_asli}</div></td>
                    <td>{s.atas_nama_role}{s.atas_nama_region ? ` · ${s.atas_nama_region}` : ""}</td>
                    <td className="whitespace-pre-wrap max-w-xs">{s.alasan || <span className="text-danger-soft-foreground">tidak ada alasan</span>}</td>
                    <td className="whitespace-nowrap">{s.dihentikan_pada ? formatDateTime(s.dihentikan_pada) : (s.ditutup_ttl ? "habis waktu" : "—")}</td>
                    <td className="px-4 text-right">
                      {s.tindakan?.jumlah ?? 0}
                      {Object.keys(s.tindakan?.per_modul || {}).length > 0 && (
                        <div className="text-xs text-muted-foreground">
                          {Object.entries(s.tindakan.per_modul).map(([m, n]) => `${m} ${n}`).join(" · ")}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                {(data.sesi || []).length === 0 && (
                  <tr><td colSpan={6} className="px-4 py-3 text-muted-foreground">Tidak ada delegasi dalam {data.hari} hari terakhir.</td></tr>
                )}
              </tbody>
            </table>
          </Card>
        </>
      )}
    </div>
  );
}
